(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-header-rebuild"]) return;
  try {
    
(() => {
  const init = (header) => {
    if (header.dataset.smInitialized === 'true') return;
    header.dataset.smInitialized = 'true';

    const shop = header.querySelector('[data-sm-shop]');
    const roots = [...header.querySelectorAll('[data-sm-root]')];
    const rootPanels = [...header.querySelectorAll('[data-sm-root-panel]')];
    const children = [...header.querySelectorAll('[data-sm-child]')];
    const childPanels = [...header.querySelectorAll('[data-sm-child-panel]')];
    const canHover = window.matchMedia('(hover: hover)').matches;
    const clubCash = header.querySelector('[data-sm-header-club-cash]');
    const clubCashAmount = header.querySelector('[data-sm-header-club-cash-amount]');

    const loadHeaderClubCash = async (force = false) => {
      if (!clubCash || !clubCashAmount) return;

      const cacheKey = 'sm-club:header-balance:v1';
      const cacheTtl = 3 * 60 * 1000;
      let availablePesewas = null;

      try {
        if (force) sessionStorage.removeItem(cacheKey);

        const cached = sessionStorage.getItem(cacheKey);
        if (cached) {
          const parsed = JSON.parse(cached);
          if (Date.now() - Number(parsed.cached_at || 0) < cacheTtl) {
            availablePesewas = Math.max(0, Number(parsed.available_pesewas || 0));
          } else {
            sessionStorage.removeItem(cacheKey);
          }
        }

        if (availablePesewas === null) {
          const controller = new AbortController();
          const timeout = window.setTimeout(() => controller.abort(), 1800);

          try {
            const response = await fetch('/apps/sm-club/header-balance', {
              credentials: 'same-origin',
              cache: 'no-store',
              headers: { Accept: 'application/json' },
              signal: controller.signal,
            });

            if (!response.ok) throw new Error('SM Club balance unavailable');
            const payload = await response.json();
            availablePesewas = Math.max(0, Number(payload?.available_pesewas || 0));
          } finally {
            window.clearTimeout(timeout);
          }

          sessionStorage.setItem(cacheKey, JSON.stringify({
            available_pesewas: availablePesewas,
            cached_at: Date.now(),
          }));
        }

        if (availablePesewas <= 0) {
          clubCash.hidden = true;
          return;
        }

        const formatted = (availablePesewas / 100).toLocaleString('en-GH', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });

        clubCashAmount.textContent = `GH₵${formatted}`;
        clubCash.setAttribute('aria-label', `GH₵${formatted} Club Cash. Open SM Club.`);
        clubCash.hidden = false;
      } catch (_) {
        clubCash.hidden = true;
      }
    };

    if (clubCash) {
      loadHeaderClubCash();
      header._smClubCashChangedHandler = () => loadHeaderClubCash(true);
      window.addEventListener('sm-club:balance-changed', header._smClubCashChangedHandler);
    }

    let childHoverTimer = null;
    let pointerTrail = [];
    const childIntentDelay = 300;
    const childIntentMaxHold = 720;

    const clearChildHover = () => {
      if (childHoverTimer) {
        window.clearTimeout(childHoverTimer);
        childHoverTimer = null;
      }
    };

    const activeChildPanel = () => childPanels.find((panel) => !panel.hidden);

    const movingTowardActiveChildPanel = () => {
      const panel = activeChildPanel();
      if (!panel || pointerTrail.length < 2) return false;

      const rect = panel.getBoundingClientRect();
      const current = pointerTrail[pointerTrail.length - 1];
      let previous = pointerTrail[0];

      for (let i = pointerTrail.length - 2; i >= 0; i -= 1) {
        if (current.t - pointerTrail[i].t >= 55) {
          previous = pointerTrail[i];
          break;
        }
      }

      const dx = current.x - previous.x;
      if (dx <= 3 || current.x >= rect.right) return false;

      const dy = current.y - previous.y;
      const distanceToPanel = rect.left - current.x;

      if (distanceToPanel <= 0) {
        return current.y >= rect.top - 28 && current.y <= rect.bottom + 28;
      }

      const projectedY = current.y + (dy / dx) * distanceToPanel;
      const verticalGrace = 34;

      return projectedY >= rect.top - verticalGrace &&
        projectedY <= rect.bottom + verticalGrace;
    };

    const scheduleChildActivation = (button) => {
      clearChildHover();

      const key = button.dataset.smChild;
      if (!key || button.classList.contains('is-active')) return;

      const startedAt = performance.now();

      const attempt = () => {
        if (!button.matches(':hover')) {
          childHoverTimer = null;
          return;
        }

        const heldFor = performance.now() - startedAt;
        if (movingTowardActiveChildPanel() && heldFor < childIntentMaxHold) {
          childHoverTimer = window.setTimeout(attempt, 110);
          return;
        }

        childHoverTimer = null;
        activateChild(key);
      };

      childHoverTimer = window.setTimeout(attempt, childIntentDelay);
    };

    if (canHover && shop) {
      shop.addEventListener('pointermove', (event) => {
        if (event.pointerType && event.pointerType !== 'mouse') return;

        const now = performance.now();
        pointerTrail.push({ x: event.clientX, y: event.clientY, t: now });
        pointerTrail = pointerTrail
          .filter((point) => now - point.t <= 420)
          .slice(-8);
      }, { passive: true });

      childPanels.forEach((panel) => {
        panel.addEventListener('mouseenter', clearChildHover);
      });
    }

    const activateChild = (key) => {
      clearChildHover();

      children.forEach((button) => {
        const active = button.dataset.smChild === key;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      childPanels.forEach((panel) => {
        panel.hidden = panel.dataset.smChildPanel !== key;
      });
    };

    const activateRoot = (key) => {
      clearChildHover();

      roots.forEach((button) => {
        const active = button.dataset.smRoot === key;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      let activePanel = null;
      rootPanels.forEach((panel) => {
        const active = panel.dataset.smRootPanel === key;
        panel.hidden = !active;
        if (active) activePanel = panel;
      });

      const firstChild = activePanel?.querySelector('[data-sm-child]');
      if (firstChild) activateChild(firstChild.dataset.smChild);
    };

    roots.forEach((button) => {
      button.addEventListener('click', () => activateRoot(button.dataset.smRoot));
      button.addEventListener('focus', () => activateRoot(button.dataset.smRoot));
      if (canHover) button.addEventListener('mouseenter', () => activateRoot(button.dataset.smRoot));
    });

    children.forEach((button) => {
      button.addEventListener('click', () => activateChild(button.dataset.smChild));
      button.addEventListener('focus', () => activateChild(button.dataset.smChild));

      if (canHover) {
        button.addEventListener('mouseenter', () => scheduleChildActivation(button));
        button.addEventListener('mouseleave', clearChildHover);
      }
    });

    if (shop) {
      document.addEventListener('click', (event) => {
        if (shop.open && !shop.contains(event.target)) shop.removeAttribute('open');
      });

      shop.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && shop.open) {
          shop.removeAttribute('open');
          shop.querySelector('summary')?.focus();
        }
      });
    }

    const openButton = header.querySelector('[data-sm-mobile-open]');
    const drawer = header.querySelector('[data-sm-mobile-drawer]');
    const visibleHeader = header.querySelector('.header__grid');
    const mobilePanel = header.querySelector('[data-sm-mobile-panel]');
    const mobileScreens = [...header.querySelectorAll('[data-sm-mobile-screen]')];
    const mobileRootButtons = [...header.querySelectorAll('[data-sm-mobile-root]')];
    const mobileChildButtons = [...header.querySelectorAll('[data-sm-mobile-child]')];
    const mobileBackButtons = [...header.querySelectorAll('[data-sm-mobile-back]')];

    const syncDrawerTop = () => {
      if (!drawer || !visibleHeader || drawer.hidden) return;
      const rect = visibleHeader.getBoundingClientRect();
      drawer.style.setProperty('--sm-mobile-drawer-top', Math.max(0, rect.bottom) + 'px');
    };

    const showMobileScreen = (key, focusTarget = null) => {
      mobileScreens.forEach((screen) => {
        screen.hidden = screen.dataset.smMobileScreen !== key;
      });

      if (mobilePanel) {
        mobilePanel.scrollTop = 0;
      }

      requestAnimationFrame(() => {
        if (focusTarget) focusTarget.focus({ preventScroll: true });
      });
    };

    const setDrawer = (open) => {
      if (!drawer || !openButton) return;

      drawer.hidden = !open;
      openButton.setAttribute('aria-expanded', open ? 'true' : 'false');
      openButton.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');

      if (open) {
        showMobileScreen('root');
        requestAnimationFrame(syncDrawerTop);
        document.documentElement.style.overflow = 'hidden';
      } else {
        drawer.style.removeProperty('--sm-mobile-drawer-top');
        document.documentElement.style.overflow = '';
      }
    };

    mobileRootButtons.forEach((button) => {
      button.addEventListener('click', () => {
        showMobileScreen('root-' + button.dataset.smMobileRoot);
      });
    });

    mobileChildButtons.forEach((button) => {
      button.addEventListener('click', () => {
        showMobileScreen('child-' + button.dataset.smMobileChild);
      });
    });

    mobileBackButtons.forEach((button) => {
      button.addEventListener('click', () => {
        showMobileScreen(button.dataset.smMobileBack);
      });
    });

    openButton?.addEventListener('click', () => {
      setDrawer(openButton.getAttribute('aria-expanded') !== 'true');
    });

    window.addEventListener('resize', syncDrawerTop);
    window.addEventListener('orientationchange', syncDrawerTop);

    header.querySelector('[data-sm-supplymate]')?.addEventListener('click', (event) => {
      event.preventDefault();

      if (shop?.open) {
        shop.removeAttribute('open');
      }

      window.dispatchEvent(new CustomEvent('supplymate:open', {
        detail: { source: 'header-mega-menu' }
      }));
    });
  };

  const boot = () => document.querySelectorAll('[data-sm-header]').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', (event) => {
    const header = event.target?.querySelector?.('[data-sm-header]');
    if (header?._smClubCashChangedHandler) {
      window.removeEventListener('sm-club:balance-changed', header._smClubCashChangedHandler);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
